import React, { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { useCart } from "../context/CartContext";
import { Minus, Plus, Trash2, Loader2 } from "lucide-react";
import { createCheckout } from "../lib/api";
import { toast } from "sonner";

export default function CartSheet() {
  const { items, open, setOpen, updateQty, removeItem, total } = useCart();
  const [loading, setLoading] = useState(false);

  const checkout = async () => {
    if (!items.length) return;
    setLoading(true);
    try {
      const { checkout_url } = await createCheckout({
        items: items.map((i) => ({ lookup_key: i.lookup_key, quantity: i.qty })),
        origin_url: window.location.origin,
      });
      window.location.href = checkout_url;
    } catch (e) {
      toast.error("Could not start checkout. Please try again.");
      setLoading(false);
    }
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-sheet" className="bg-[#EDEAF2] border-l border-[#DAD5E2] flex flex-col w-full sm:max-w-md">
        <SheetHeader>
          <SheetTitle className="font-display text-3xl tracking-tight text-left">Your Cart</SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto py-6 space-y-6">
          {items.length === 0 && (
            <p className="text-[#8B8494] text-center mt-20">Your cart is empty.</p>
          )}
          {items.map((i) => (
            <div key={i.id} data-testid={`cart-item-${i.id}`} className="flex gap-4">
              <div className="w-20 h-24 bg-white overflow-hidden rounded-md flex-shrink-0">
                <img src={i.image} alt={i.name} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1">
                <p className="font-display text-lg leading-tight">{i.name}</p>
                <p className="text-sm text-[#8B8494] mb-2">${i.price.toFixed(2)}</p>
                <div className="flex items-center gap-3">
                  <button data-testid={`cart-dec-${i.id}`} onClick={() => updateQty(i.id, i.qty - 1)} className="p-1 border border-[#DAD5E2] rounded-full"><Minus className="w-3 h-3" /></button>
                  <span className="text-sm w-5 text-center">{i.qty}</span>
                  <button data-testid={`cart-inc-${i.id}`} onClick={() => updateQty(i.id, i.qty + 1)} className="p-1 border border-[#DAD5E2] rounded-full"><Plus className="w-3 h-3" /></button>
                  <button data-testid={`cart-remove-${i.id}`} onClick={() => removeItem(i.id)} className="ml-auto text-[#8C3B3B]"><Trash2 className="w-4 h-4" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="border-t border-[#DAD5E2] pt-5">
            <div className="flex justify-between mb-4">
              <span className="text-[#57515F]">Subtotal</span>
              <span data-testid="cart-total" className="font-display text-2xl">${total.toFixed(2)}</span>
            </div>
            <button data-testid="checkout-button" onClick={checkout} disabled={loading} className="btn-primary w-full justify-center">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Checkout"}
            </button>
            <p className="text-xs text-[#8B8494] text-center mt-3">Secure payment via Stripe · Tax calculated at checkout</p>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
